export default {
  newDesign: true,
  parameters: {
    landing_id: "ItQMine",
    segment: 9,
    success_page: "it_thankyou_page_fwd2",
  },
  title: "Corso gratuito per sviluppatori di giochi per bambini | Kodland",
  downtimeUrl: "https://www.kodland.org/it",
  startPage: {
    title:
      "Rispondi a 5 domande e ricevi un invito a un corso di programmazione GRATUITO su Minecraft!",
    subtitle:
      "Tuo figlio/a creerà il proprio gioco e noi gli mostreremo come sfruttare il suo interesse per la tecnologia in modo positivo.",
    image: {
      url: "/welcome/it_quiz_mine_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/it_quiz_mine_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Clicca qui per iscriverti 🚀 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Grazie per aver scelto la nostra piattaforma educativa!",
    subtitle:
      'Si prega di notare che i nostri corsi richiedono una tastiera e un mouse; quindi telefoni, tablet e dispositivi privi di queste caratteristiche non sono compatibili. Per rimanere sempre aggiornato/a sulle nostre novità, puoi seguirci su <a href="https://www.instagram.com/kodland.it/" target="_blank">Instagram</a> 💙',
  },
  quizRotateBySteps: {
    1: {
      question:
        "Quanto tempo trascorre tuo/a figlio/a con i dispositivi elettronici al giorno?",
      answers: ["😍 1 ora", "😊 2-3 ore", "😐 Più di 4 ore"],
    },
    2: {
      question: "Qual è la personalità di tuo/a figlio/a?",
      subtitle:
        "La risposta ci aiuterà a scegliere la corretta metodologia di insegnamento",
      answers: [
        "👦 Attivo, comunica tanto",
        "🌙 Sognatore",
        "🤔 Non sa bene cosa vuole",
        "😳 Timido",
        "🌱 Tranquillo, è solitario",
      ],
    },
    3: {
      question:
        "Cosa è importante per te durante una lezione (seleziona le tre opzioni più importanti)?",
      answers: [
        "🤝 Connettersi con tuo/a figlio/a",
        "🚀 Vedere risultati subito",
        "🎯 Motivazione e interesse",
        "🔧 Abilità utili per il futuro",
        "😊 Atmosfera amichevole",
        "💻 Una piattaforma di apprendimento",
      ],
    },
    4: {
      question: "Come valuti la motivazione di tuo/a figlio/a ad apprendere?",
      answers: ["🔥 Alta", "🙂 Normale", "😴 Bassa"],
    },
    5: {
      title: "Quanti anni ha tuo figlio/a?",
      type: "age",
      button: "",
    },
    6: {
      question: "Hai un computer/portatile per studiare?",
      answers: [
        "✔️ Sì",
        {
          answer: "❌ No",
          stopAnswer: true,
        },
      ],
    },
    7: {
      title: "Congratulazioni! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Clicca su '📆 Prenota una lezione' per completare la registrazione. Ti invieremo un video corso e l'accesso alla nostra piattaforma non appena riceveremo la tua richiesta.",
      button: "📆 Prenota una lezione",
    },
    8: {
      title: "Prenota una lezione gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "👏 Perfetto. Manca l'ultimo passaggio!",
    },
    9: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    10: {
      title: "Controlla questi dettagli per completare la registrazione ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ti ricordiamo che per la lezione avrai bisogno di un PC o laptop funzionante e che dovrai accompagnare tuo figlio per tutta la lezione. Ricorda che è individuale e personalizzato.",
      button: "Cos'altro?",
    },
    11: {
      title:
        "Controlla la tua email e WhatsApp prima della lezione di prova 📞",
      typeInfo: "whatsapp",
      subtitle:
        "24 ore prima della lezione ti invieremo un promemoria e 2 ore prima della lezione ti chiederemo di confermare la tua presenza. È molto importante rimanere in contatto affinché la lezione non venga annullata.",
      button: "Cos'altro?",
    },
    12: {
      title: "La lezione si svolgerà sulla nostra piattaforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Riceverai un link e un codice univoco via WhatsApp ed email. Basta cliccare sul link, ti porterà direttamente alla lezione. Senza app aggiuntive e senza download.",
      button: "Ho capito ✅",
    },
  },
};
